@if(_loadingService.isLoading()){
    <acrylic-loader></acrylic-loader>
}

<acrylic-alert></acrylic-alert>

<router-outlet />